var $4f8cc713dc594518$exports = {};
(function() {
    'use strict';
    document.addEventListener('DOMContentLoaded', function() {
        var root = document.querySelector('.fpu-apply');
        if (!root) return;
        if (window.applySmoothScroll && typeof window.applySmoothScroll.bind === 'function') window.applySmoothScroll.bind(root);
        if (window.applyAccordion && typeof window.applyAccordion.init === 'function') window.applyAccordion.init(root);
    });
})();


//# sourceMappingURL=root.js.map
